export default __webpack_public_path__ + "static/media/slide12.37a8ab01.jpg";